/**
 * Утилиты для модуля истории поиска
 */

// The ONE history escaper (BL-050): & < > " ' — safe in text and in quoted attributes.
// The old textContent→innerHTML trick left quotes raw, so a history record broke out of
// data-*="…" attributes. Unique name: other bundles shadow the global `escapeHtml`.
function historyEscapeHtml(text) {
  if (text === null || text === undefined) {
    return '';
  }
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
window.historyEscapeHtml = historyEscapeHtml;

function escapeHtml(text) {
  return historyEscapeHtml(text);
}

